import 'flickity/dist/flickity.pkgd'
import axios from 'axios';

jQuery(document).ready(function($) {
    var imageData = jQuery('#image-data');
    if (imageData.length) {
        var images = JSON.parse(imageData.attr('data-images'));
        var randomIndex = Math.floor(Math.random() * images.length);
        var heroImage = $('#hero-image');
        heroImage.attr('src', images[randomIndex] + '?rand=' + Math.random());
    }
});
